// extracted by mini-css-extract-plugin
module.exports = {"container":"symbol-card_container__CDjuP","img":"symbol-card_img__Z2bRx","download":"symbol-card_download__8AUDo","button":"symbol-card_button__fzZDT"};